import { render, staticRenderFns } from "./TomWidget.vue?vue&type=template&id=7e540c64&"
import script from "./TomWidget.vue?vue&type=script&lang=js&"
export * from "./TomWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TomWidget.vue"
export default component.exports